module.exports = __webpack_public_path__ + "static/media/diktat-37.39bf80ea.mp3";